module.exports = __webpack_public_path__ + "static/life-in-barcelona-af1522bc0b867c5f3aba0560995f0b69.jpg";